import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";

import CustomModal from "../../../components/Modal/CustomModal";

import { ConsultCuentaAdmin } from "../../../funciones/EstCuentaFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

import DatosInscripcion from "../../Inscripcion/DatosInscripcion";

class ListAdmisionTable extends Component {
    state = {
        openMaterias: false,
        openCuenta: false,
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando datos</React.Fragment>,
        asientos: [],
    }

    modalInscripcion = () => {
        let {openMaterias} = this.state;
        let { Datos, Estudiante, EstCuenta } = this.props;

        let contenido = () => (
            <DatosInscripcion idEst={Datos.id_est }
            tlf = {Datos.tlf_hab} cel = {Datos.tlf_cel}
            EstCuenta = {EstCuenta}
            email = {Datos.email}/>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Aceptar</React.Fragment>}
                boton1 = ""
                large = "large"
                isopen =  {openMaterias}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Materias Inscritas de ${Estudiante}`}</div>}
                contenido = {contenido()}      
                funcion2 = {() => {this.setState({openMaterias: false})}}
            />
        );
    }

    modalCuenta = () => {
        let { openCuenta, asientos, preloader } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let contentEstado = () => {
            if (asientos.length === 0) return (
                <tr>
                    <td colSpan={7} align="center">{preloader}</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            return (
                asientos.map(option => (
                    <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                        <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                        <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                        <td align="center" style={stylesBs}>
                            {formatNumber(option.saldo)}
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                        </td>
                        <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                    </tr>
                ))
            )
        }

        let contenidoModal = () => (
            <React.Fragment>
                <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                    <Table striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                <td width="40%" style={styles}><strong>Descripción</strong></td>
                                <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                <td width="30px" align="center" style={styles}></td>
                            </tr>
                            {contentEstado()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = ""
                boton1 = {<React.Fragment><i className="fa fa-times"></i> Cerrar</React.Fragment>}
                large = "large"
                isopen =  {openCuenta}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Estado de Cuenta de <strong>{this.props.Estudiante}</strong></div>}
                contenido = {contenidoModal()}      
                funcion1 = {() => {this.setState({
                    openCuenta: false,
                    asientos: [],
                    preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando datos</React.Fragment>,
                })}}
            />
        );
    }

    render() {
        let { Datos, Materia, N, EstCuenta, Semestres, SemAlto } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        let SemCard = ["1er", "2do", "3er", "4to", "5to", "6to", "7mo", "8vo", "9no", "10mo"];

        let Sem = (Semestres) => {
            let num = 0;
            return (
                Semestres.map(option => {
                    num++;
                    return (
                        <div key = {num}>
                            <div style= {{fontSize: 10}}>{SemCard[option.SEM - 1]} Semestre | Materias: {option.MATERIAS}</div>
                        </div>
                    )
                })
            )
        }

        let menu = () => {
            if(EstCuenta === false) return(
                <Popover bsSize="large" id="acciones">
                    <div className="text-warning" onClick ={() => {this.setState({openMaterias:true})}} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Ver las Materias Inscritas"><i className="fa fa-address-book"></i> Ver Materias Inscritas</div>
                </Popover>  
            )

            return (
                <Popover bsSize="large" id="acciones">
                    <div className="text-danger" style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Ver Estado de Cuenta"  onClick={() => {
                        this.setState({
                            openCuenta: true
                        }, () => {
                            ConsultCuentaAdmin (Datos.id_est, (resp)=> {
                                this.setState({
                                    asientos: resp
                                })
                            })
                        }) }}><i className="fa fa-th-list"></i> Estado de Cuenta</div>
                    <div className="text-warning" onClick ={() => {this.setState({openMaterias:true})}} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Ver las Materias Inscritas"><i className="fa fa-address-book"></i> Ver Materias Inscritas</div>
                </Popover>
            )
        }

        return (
            <React.Fragment>
                <tr>
                    <td style={styles} align="center"><strong>{N}</strong></td>
                    <td style={styles}>
                        <div className="text-danger" style={{fontSize: 11}}><strong>{`${Datos.nacionalidad} ${Datos.ci} - ${Datos.nombre_1} ${Datos.nombre_2} ${Datos.apellido_1}  ${Datos.apellido_2}`}</strong></div>
                        <div style={{fontSize: 11}}><strong>{`Tlf 1: ${Datos.tlf_hab} | Tlf 2: ${Datos.tlf_cel}`}</strong></div>
                        <div className="text-primary" style={{fontSize: 11}}><strong>Correo: </strong>{Datos.email}</div>
                        <div style={{fontSize: 11}}><strong>Lug. Nacimiento: </strong>{(Datos.estado_name).toUpperCase()}</div>
                    </td>
                    <td style={styles} align="left">
                        <div align="center"><strong className="text-danger">{SemCard[SemAlto - 1]} Semestre</strong></div>
                        <div align="center"><strong>{Materia} Materias Inscritas</strong></div>
                        <div style = {{borderTop: "1px solid #000", marginTop: 2, paddingTop: 2}}>{Sem(Semestres)}</div>
                    </td>
                    <td style={styles} align="center">
                        <OverlayTrigger trigger="focus" placement="right" overlay={menu()}>
                            <button className="btn btn-primary" title= "Haz click aqui para ver las opciones disponibles" style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.modalInscripcion()}
                {this.modalCuenta()}
            </React.Fragment>
        );
    }
}
 
export default ListAdmisionTable;


// WEBPACK FOOTER //
// ./src/views/AdmisionAdmin/AdmisionAdminContent/ListAdmisionTable.jsx